// import React, { useEffect, useState } from "react";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   Legend,
// } from "recharts";
// import rpmService from "../../../../Services/rpmService";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchRpmLocationWiseChronics } from "../../../../Redux/actions/rpmActions";
// import dayjs from "dayjs";

// const data = [
//   {
//     location: "AK",
//     cancer: 12,
//     cardiovascular: 15,
//     cad: 18,
//   },
//   {
//     location: "BZ",
//     cancer: 14,
//     cardiovascular: 13,
//     cad: 19,
//   },
//   {
//     location: "SD",
//     cancer: 16,
//     cardiovascular: 12,
//     cad: 20,
//   },
//   {
//     location: "VK",
//     cancer: 18,
//     cardiovascular: 14,
//     cad: 17,
//   },
//   {
//     location: "GT",
//     cancer: 17,
//     cardiovascular: 13,
//     cad: 21,
//   },
//   {
//     location: "JF",
//     cancer: 13,
//     cardiovascular: 12,
//     cad: 19,
//   },
//   {
//     location: "AH",
//     cancer: 15,
//     cardiovascular: 11,
//     cad: 18,
//   },
//   {
//     location: "GY",
//     cancer: 14,
//     cardiovascular: 12,
//     cad: 20,
//   },
//   {
//     location: "SU",
//     cancer: 19,
//     cardiovascular: 14,
//     cad: 23,
//   },
//   {
//     location: "FR",
//     cancer: 16,
//     cardiovascular: 13,
//     cad: 17,
//   },
//   {
//     location: "DR",
//     cancer: 15,
//     cardiovascular: 12,
//     cad: 18,
//   },
// ];

// function LocationwiseChronic() {
//   const {rpmLocWiseChronicList} = useSelector((state) => state.rpm);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     const payload = {
//       fromDate: dayjs().startOf('month').format('MM/DD/YYYY'),
//       toDate: dayjs().endOf('month').format('MM/DD/YYYY'),
//       status: 1
//     }
//     dispatch(fetchRpmLocationWiseChronics(payload));
//   }, []);

//   return (
//     <div className="xl:w-1/2 lg:w-1/2 w-full">
//       <div className="bg-white rounded-lg xl:p-4 lg:p-4 md:p-4 shadow border w-full p-2">
//         <h2 className="font-semibold font-inter text-gray-800 text-base mb-2">
//           Location Wise Chronic Conditions
//         </h2>
//         <div className="relative">

//           <ResponsiveContainer width="100%" height={300}>
//             <BarChart data={data} barCategoryGap={10} barGap={2} barSize={25}>
//               <CartesianGrid strokeDasharray="3 3" vertical={false} />
//               <XAxis dataKey="location" tick={{ fontSize: 12 }} />
//               <YAxis tick={{ fontSize: 12 }} />
//               <Tooltip contentStyle={{ fontSize: 12 }} />
//               <Legend wrapperStyle={{ fontSize: 12 }} />
//               <Bar
//                 dataKey="cancer"
//                 stackId="a"
//                 fill="#002b6f"
//                 name="Cancer and Malignancy"
//                 className="text-xs"
//               />
//               <Bar
//                 dataKey="cardiovascular"
//                 stackId="a"
//                 fill="#3370cc"
//                 name="Cardiovascular"
//               />
//               <Bar
//                 dataKey="cad"
//                 stackId="a"
//                 fill="#74acf2"
//                 name="Cardiovascular (CAD)"
//               />
//             </BarChart>
//           </ResponsiveContainer>
//           <div className="absolute bottom-2 right-6 xl:flex lg:flex items-center text-xs hidden md:block">
//             <span className="text-green-600 cursor-pointer">▲</span>
//             <span className="text-gray-700 font-medium">1/9</span>
//             <span className="text-red-500 cursor-pointer">▼</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default LocationwiseChronic;

import React, { useEffect, useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";
import { fetchRpmLocationWiseChronics } from "../../../../Redux/actions/rpmActions";
import dayjs from "dayjs";

function LocationwiseChronic() {
  const { rpmLocWiseChronicList } = useSelector((state) => state.rpm);
  const dispatch = useDispatch();
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    const payload = {
      fromDate: dayjs().startOf("month").format("MM/DD/YYYY"),
      toDate: dayjs().endOf("month").format("MM/DD/YYYY"),
      status: 1,
    };

    // payload.account_Id = loggedUser.user.account_Id;
    payload.clinic_Id = loggedUser.user.clinic_Id;
    dispatch(fetchRpmLocationWiseChronics(payload));
  }, [dispatch]);

  // Group chronic conditions by state
  const chartData = useMemo(() => {
    const grouped = {};

    rpmLocWiseChronicList?.forEach((item) => {
      const state = item.stateId;
      if (!grouped[state]) {
        grouped[state] = { location: state };
      }
      grouped[state][item.chronicDescription] = item.patientCount;
    });

    return Object.values(grouped);
  }, [rpmLocWiseChronicList]);

  // Get all unique chronic types (used in rendering bars)
  const chronicKeys = useMemo(() => {
    const keys = new Set();
    rpmLocWiseChronicList?.forEach((item) => {
      keys.add(item.chronicDescription);
    });
    return Array.from(keys);
  }, [rpmLocWiseChronicList]);

  const colors = [
    "#002b6f",
    "#3370cc",
    "#74acf2",
    "#F59E0B",
    "#10B981",
    "#EF4444",
    "#6366F1",
    "#E879F9",
    "#F87171",
    "#60A5FA",
    "#34D399",
    "#A78BFA",
  ];

  return (
    <div className="xl:w-1/2 lg:w-1/2 w-full">
      <div className="bg-white rounded-lg xl:p-4 lg:p-4 md:p-4 shadow border w-full p-2">
        <h2 className="font-semibold font-inter text-gray-800 text-base mb-2">
          Location Wise Chronic Conditions
        </h2>
        <div className="relative">
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              data={chartData}
              barCategoryGap={10}
              barGap={2}
              barSize={25}
            >
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="location" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip contentStyle={{ fontSize: 12 }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              {chronicKeys.map((key, index) => (
                <Bar
                  key={key}
                  dataKey={key}
                  stackId="a"
                  fill={colors[index % colors.length]}
                  name={key}
                />
              ))}
            </BarChart>
          </ResponsiveContainer>
          <div className="absolute bottom-2 right-6 xl:flex lg:flex items-center text-xs hidden md:block">
            <span className="text-green-600 cursor-pointer">▲</span>
            <span className="text-gray-700 font-medium">1/9</span>
            <span className="text-red-500 cursor-pointer">▼</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LocationwiseChronic;
